import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['signUpConfirmationManually', 'resendSignUpConfirmation']),
    resendActivationLink(item, type) {
      const channel = type === 'EMAIL' ? 'E-mail' : 'SMS'
      this.$confirm({
        title: `Reenviar ${channel} de ativação`,
        message: `Tem certeza que deseja reenviar um ${channel} de ativação para ${item.name}?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          const input = {
            userId: item._id,
            type,
          }
          await this.resendSignUpConfirmation(input)
            .then(({ resendSignUpConfirmation }) => {
              if (resendSignUpConfirmation.sent) {
                this.$snackbar({ message: `O ${channel} de ativação foi enviado com sucesso.`, snackbarColor: 'success' })
              } else {
                this.$snackbar({ message: `Erro ao enviar ${channel} de ativação.`, snackbarColor: 'error' })
              }
            })
            .catch((error) => {
              console.error(error)
              this.$snackbar({ message: `Erro ao enviar ${channel} de ativação.`, snackbarColor: 'error' })
            })
        })
        .catch(() => false)
    },
    activateManually(item) {
      this.$confirm({
        title: 'Ativar cadastro',
        message: 'Tem certeza que deseja ativar esse cadastro?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.signUpConfirmationManually(item._id)
            .then(({ signUpConfirmationManually }) => {
              if (signUpConfirmationManually.wasConfirmated) {
                this.reloadDataAfterActivation()
                this.$snackbar({ message: 'Cadastro ativado com sucesso.', snackbarColor: 'success' })
              } else {
                this.$snackbar({ message: 'Erro ao ativar cadastro.', snackbarColor: 'error' })
              }
            })
            .catch((error) => {
              console.error(error)
              this.$snackbar({ message: 'Erro ao ativar cadastro.', snackbarColor: 'error' })
            })
        })
        .catch(() => false)
    },
  },
}
